import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import BackspaceIcon from '@material-ui/icons/Backspace';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import SaveIcon from '@material-ui/icons/Save';
import { THEME } from 'GlobalStyles';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';

const COPIES = strings.shared.savedSearches;

export const SearchApplied = ({
  isDirty = false,
  onRemoveSearch = null,
  onSaveSearch = null,
  searchName = null
}) => {
  return (
    <Box alignItems="center" display="flex" flexDirection="row">
      <Typography variant="body1">
        {COPIES.activeSearch} <b>{searchName}</b>
      </Typography>

      <Box alignItems="center" display="flex" ml={1}>
        <FPIconButton
          disabled={!onSaveSearch}
          family="mini"
          icon={isDirty ? SaveIcon : EditRoundedIcon}
          iconMode="custom"
          iconProps={{
            color: onSaveSearch
              ? THEME.palette.primary.main
              : THEME.palette.customColors.iconInactive
          }}
          disableFocusRipple
          disableRipple
          onClick={onSaveSearch}
          tooltipProps={{ title: isDirty ? COPIES.saveSearch : COPIES.editSearch }}
        />

        {onRemoveSearch && (
          <FPIconButton
            family="mini"
            icon={BackspaceIcon}
            iconMode="custom"
            iconProps={{ color: THEME.palette.primary.main }}
            onClick={onRemoveSearch}
            tooltipProps={{ title: COPIES.removeAppliedSearch }}
          />
        )}
      </Box>
    </Box>
  );
};
